import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { GlobalLoadingService } from './global-loading.service';
import { SKIP_GLOBAL_LOADING } from './skip-global-loading.context';

/** URLs that should not trigger the global spinner (e.g. translation JSON). */
function shouldSkipLoading(url: string): boolean {
  const u = url.toLowerCase();
  return u.includes('/assets/i18n/') || u.includes('/i18n/');
}

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private readonly globalLoading: GlobalLoadingService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (shouldSkipLoading(request.url) || request.context.get(SKIP_GLOBAL_LOADING)) {
      return next.handle(request);
    }

    this.globalLoading.begin();
    return next.handle(request).pipe(
      finalize(() => {
        this.globalLoading.end();
      })
    );
  }
}
